module.exports = __webpack_public_path__ + "static/img/color.e0bae5c9.png";